import { LuCircleAlert, LuX } from 'react-icons/lu'

import { ModalBase } from '@/lib/core/components/Modal/ModalBase'

import { useConfirmDeleteAlert } from './useConfirmDeleteAlert'
import styles from './ConfirmDeleteAlertModal.module.css'

export const ConfirmDeleteAlertModal = () => {
  const { isDeleteAlertOpen, closeDeleteAlert, alertToDelete, isMutating, handleDelete } =
    useConfirmDeleteAlert()

  if (!alertToDelete) return null

  return (
    <ModalBase
      isActive={isDeleteAlertOpen}
      onEscape={closeDeleteAlert}
      dataTestId="confirm-delete-alert-modal"
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.headerTitle}>Warning</span>
          <button
            className={styles.closeButton}
            type="button"
            onClick={closeDeleteAlert}
            data-testid="confirm-delete-alert-close"
          >
            <LuX size={20} />
          </button>
        </div>

        <div className={styles.body}>
          <LuCircleAlert size={75} className={styles.warningIcon} />
          <p className={styles.message}>Are you sure you want to discard this alert?</p>
        </div>

        <div className={styles.footer}>
          <button
            className={`${styles.footerButton} ${styles.cancelButton}`}
            type="button"
            onClick={closeDeleteAlert}
            data-testid="confirm-delete-alert-cancel"
          >
            Keep editing
          </button>
          <button
            className={`${styles.footerButton} ${styles.deleteButton}`}
            type="button"
            onClick={handleDelete}
            disabled={isMutating}
            data-testid="confirm-delete-alert-confirm"
          >
            {isMutating ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </ModalBase>
  )
}
